import React, {Component} from 'react';

import './VideoPlayer.scss';

import VideoPlayerHeader from './VideoPlayerHeader';

class VideoPlayer extends Component {

	constructor(props) {
		super(props);
		// create a ref to store the textInput DOM element
		this.videoPlayer = React.createRef();

		this.state = {
			videoWidth: 	undefined,
			videoHeight: 	undefined,
			videoReady: 	false
		}
	}

	/**
	 * When video is ready to play, we get all infos
	 */
	onVideoCanPlay = () => {
		if( this.props.toggleVideoReady ){
			this.props.toggleVideoReady();
		}

		let stateUpdate = {
			videoWidth: this.videoPlayer.current.videoWidth,
			videoHeight: this.videoPlayer.current.videoHeight,
		};

		// Tells top container about the size to use on other video containers
		this.props.setPanelPlayersSize(this.videoPlayer.current.offsetWidth, this.videoPlayer.current.offsetHeight);

		// if there is a navto upon video ready => go to it
		if( this.props.navTo ){
			let setVideoReadyOneTimeHasBeenAdjusted = () => {
				this.setState({videoReady: true});
				this.videoPlayer.current.removeEventListener('timeupdate',setVideoReadyOneTimeHasBeenAdjusted);
			};
			this.videoPlayer.current.addEventListener('timeupdate', setVideoReadyOneTimeHasBeenAdjusted);
			this.videoPlayer.current.currentTime = this.props.navTo;
		} else { // Else video is good
			stateUpdate.videoReady = true;
		}

		this.setState(stateUpdate);

		// Remove as it can sometimes fire several times
		this.videoPlayer.current.removeEventListener('canplay', this.onVideoCanPlay)
	};

	componentDidMount() {
		// Bind timeupdate to fire playback time updates
		if (this.props.updatePlaybackTime) {
			let interval = null,
				onTimeUpdate = () => {
					this.props.updatePlaybackTime(this.videoPlayer.current.currentTime);
				};
			this.videoPlayer.current.addEventListener('playing', () => {
				this.videoPlayer.current.removeEventListener('timeupdate', onTimeUpdate);
				if( !interval ){
					interval = setInterval(() => {
						this.props.updatePlaybackTime(this.videoPlayer.current.currentTime);
					},100)
				}
			});
			this.videoPlayer.current.addEventListener('pause', () => {
				clearInterval(interval);
				interval = null;
				this.videoPlayer.current.addEventListener('timeupdate', onTimeUpdate);
			});
			this.videoPlayer.current.addEventListener('timeupdate', onTimeUpdate);

			// window.addEventListener('resize', () => {
			// 	console.log('Window resize');
			// 	// Tells top container about the size to use on other video containers
			// 	this.props.setPanelPlayersSize(this.videoPlayer.current.offsetWidth, this.videoPlayer.current.offsetHeight, true);
			// })
		}

		// Bind duration change to send back the video duration once it has loaded
		if( this.props.updateVideoDuration ){
			let onGetDuration = () => {
				this.props.updateVideoDuration(this.videoPlayer.current.duration);
				this.videoPlayer.current.removeEventListener('canplay', onGetDuration);
			};
			this.videoPlayer.current.addEventListener('canplay', onGetDuration);
		}

		// Bind on video ready
		this.videoPlayer.current.addEventListener('canplay', this.onVideoCanPlay);

		// Bind video end - force pause
		if( this.props.pausePlayState )
			this.videoPlayer.current.addEventListener('ended', () => {
				this.props.playPlayState();
			});
	}

	componentDidUpdate(prevProps) {
		// If we get a navigation value: whether different or we changed src - set to have
		if( !isNaN(this.props.navTo) && (this.props.navTo !== prevProps.navTo || prevProps.src !== this.props.src ) ){
			this.videoPlayer.current.currentTime = this.props.navTo;
		}

		if( this.videoPlayer.current.ended ){ // If video has ended -> start again at 1sec
			this.videoPlayer.current.currentTime = 1;
			this.videoPlayer.current.play();
		} else
		// If playing status does not match the props status, it means an external request was sent to toggle the playback
		if( this.props.currentlyPlaying && this.videoPlayer.current.paused ){ // To catch end: && !this.videoPlayer.current.ended
			this.videoPlayer.current.play();
		} else if( !this.props.currentlyPlaying && !this.videoPlayer.current.paused ) {
			this.videoPlayer.current.pause();
		}

		// If changing source
		if(prevProps.src !== this.props.src ){
			this.setState({
				videoReady: false,
			});
			// Bind on video ready again to ire back `videoReady`
			this.videoPlayer.current.addEventListener('canplay', this.onVideoCanPlay);
		}
	}

	/**
	 * On click on the entire element
	 * @param event
	 */
	onClickOnVideoPlayer = (event) => {
		if( this.props.isSwapMenuOpen ){
			this.props.toggleIsSwapMenuOpen();
		}
	};

	render() {
		return (
			<div className="videoPlayer"
				 onClick={this.onClickOnVideoPlayer}
			>
				<div className={`videoPlayer__header ${this.state.videoReady ? `` : `videoPlayer__header--hidden`}`}>
					<VideoPlayerHeader
						videoName={this.props.name}
						videoFps={this.props.fps}
						videoWidth={this.state.videoWidth}
						videoHeight={this.state.videoHeight}

						toggleIsSwapMenuOpen={this.props.toggleIsSwapMenuOpen}
					/>
				</div>

				<div className={`videoPlayer__spinner ${this.state.videoReady ? `videoPlayer__spinner--hidden` : `` }`}>

				</div>

				<video
					src={this.props.src}
					// loop
					controls={false}
					className={`videoPlayer__video ${this.state.videoReady ? `` : `videoPlayer__video--hidden`}`}
					ref={this.videoPlayer}
				/>
			</div>
		);
	}
}

export default VideoPlayer;
